import { render, staticRenderFns } from "./DragonEditor.vue?vue&type=template&id=4619cd20&scoped=true&"
import script from "./DragonEditor.vue?vue&type=script&lang=js&"
export * from "./DragonEditor.vue?vue&type=script&lang=js&"
import style0 from "./DragonEditor.vue?vue&type=style&index=0&id=4619cd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4619cd20",
  null
  
)

export default component.exports